import { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Rating,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Send as SendIcon, StarRounded } from '@mui/icons-material';
import TurnoInfoCard from './TurnoInfoCard';
import { OBSERVACION_MAX_LENGTH } from '../constants/calificacionConstants';

const CalificacionForm = ({ turno, isSubmitting, submitError, onSubmit }) => {
  const [valoracion, setValoracion] = useState(null);
  const [observacion, setObservacion] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!valoracion || isSubmitting) return;
    onSubmit(valoracion, observacion.trim() || null);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, sm: 3, md: 4 },
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h5"
          component="h1"
          fontWeight="700"
          gutterBottom
          sx={{ textAlign: 'center' }}
        >
          ¿Cómo fue tu atención?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
          Tu opinión nos ayuda a mejorar la atención en nuestras sedes.
        </Typography>
      </Box>

      <Stack spacing={3} component="form" onSubmit={handleSubmit} noValidate>
        <TurnoInfoCard
          nombreSede={turno?.nombreSede}
          fecha={turno?.fecha}
          hora={turno?.hora}
          codigoMostrar={turno?.codigoMostrar}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Rating
            name="valoracion"
            value={valoracion}
            onChange={(_event, newValue) => setValoracion(newValue)}
            size="large"
            emptyIcon={<StarRounded style={{ opacity: 0.3 }} fontSize="inherit" />}
            sx={{ fontSize: '3rem' }}
          />
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            Seleccioná de 1 a 5 estrellas
          </Typography>
        </Box>

        <TextField
          label="Comentario (opcional)"
          placeholder="Contanos más sobre tu experiencia"
          multiline
          minRows={3}
          fullWidth
          value={observacion}
          onChange={(event) => setObservacion(event.target.value.slice(0, OBSERVACION_MAX_LENGTH))}
          helperText={`${observacion.length}/${OBSERVACION_MAX_LENGTH}`}
          FormHelperTextProps={{ sx: { textAlign: 'right' } }}
        />

        {submitError && <Alert severity="error">{submitError}</Alert>}

        <Button
          type="submit"
          variant="contained"
          size="large"
          fullWidth
          disabled={!valoracion || isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
          sx={{ py: 1.5, fontSize: '1rem', fontWeight: 600, borderRadius: 2 }}
        >
          {isSubmitting ? 'Enviando...' : 'Enviar calificación'}
        </Button>
      </Stack>
    </Paper>
  );
};

export default CalificacionForm;
